
import TreeNode from "./TreeNode.vue";
import { SistemaMixin } from "@/modules/Application";

export default {
  name: "Tree",
  mixins: [SistemaMixin],
  components: { TreeNode },
  props: {
    treeData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeTab: "saidas",
      modalVisible: false,
      newNodeName: "",
      parentNode: null,
      newParentType: 1,
      typeOptions: [
        { text: "Saída (Despesa)", value: 1 },
        { text: "Entrada (Receita)", value: 2 },
      ],
      newDreGrupo: null,
      dreGrupos: [],
    };
  },
  computed: {
    dreGruposOptions() {
      return [
        { value: null, text: "Não classificado" },
        ...this.dreGrupos.map((g) => ({ value: g.id, text: g.label })),
      ];
    },
    filteredNodes() {
      if (this.activeTab === "entradas") return this.treeData.filter((n) => n.tipo === 2);
      return this.treeData.filter((n) => n.tipo !== 2);
    },
  },
  async mounted() {
    try {
      const { data } = await this.$http.get("/financeiro/dre-grupos");
      if (data && data.data) this.dreGrupos = data.data;
    } catch (e) {
      // silent
    }
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
      this.newParentType = tab === "entradas" ? 2 : 1;
    },
    showAddModal(parent) {
      this.parentNode = parent;
      this.newNodeName = "";
      this.newDreGrupo = null;
      this.modalVisible = true;
    },
    async saveNewNode() {
      if (!this.newNodeName) return;
      this.addLoadingToButton("saveNewNode");
      const newNode = {
        descricao: this.newNodeName,
        children: [],
        tipo: this.newParentType,
        dre_grupo: this.newDreGrupo,
      };
      try {
        if (this.parentNode) {
          newNode.id_pai = this.parentNode.id;
          const { data } = await this.$http.post("/financeiro/create-plano-filho", newNode);
          if (data.data.id) {
            newNode.id = data.data.id;
            this.$toast.success("Plano adicionado com sucesso!");
          }
          this.parentNode.children.push(newNode);
        } else {
          const { data } = await this.$http.post("/financeiro/create-plano-principal", newNode);
          if (data.data.id) {
            newNode.id = data.data.id;
            this.$toast.success("Plano adicionado com sucesso!");
            this.treeData.push(newNode);
          }
        }
      } finally {
        this.removeLoadingToButton("saveNewNode");
        this.modalVisible = false;
      }
    },
    addChild(node) {
      this.newParentType = node.tipo;
      this.showAddModal(node);
    },
    deleteNode(node) {
      this.getRequestAdmin(() => {
        this.$swal
          .fire({
            icon: "warning",
            title: "Excluir o plano de contas: " + node.descricao + "?",
            showCancelButton: true,
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            confirmButtonColor: "#f64e60",
          })
          .then(async (result) => {
            if (result.isConfirmed) {
              await this.$http.post("/financeiro/delete-plano", node);
              this.handleDeleteNode(node);
              this.$toast.success("Plano de contas excluído!");
            }
          });
      });
    },
    handleDeleteNode(deletedNode) {
      const removeNode = (nodes, nodeToRemove) => {
        return nodes.filter((node) => {
          if (node.id === nodeToRemove.id) return false;
          if (node.children) node.children = removeNode(node.children, nodeToRemove);
          return true;
        });
      };
      this.treeData = removeNode(this.treeData, deletedNode);
    },
  },
};
